import { Component, OnInit } from '@angular/core'
import { FormGroup, FormBuilder, Validators } from '@angular/forms'
import { ErrorsService } from 'src/app/core/services/errors.service'
import { StoreService } from 'src/app/services/store.service'
import { Router, ActivatedRoute } from '@angular/router'
import { TransactionService } from 'src/app/services/transaction.service'
import { Store } from 'src/app/models/store'
import { MatSnackBar } from '@angular/material'
import { CurrencyPipe } from '@angular/common'

@Component({
  selector: 'app-store-payment-anticipated-transaction-form',
  templateUrl: './store-payment-anticipated-transaction-form.component.html',
  styleUrls: ['./store-payment-anticipated-transaction-form.component.scss'],
})
export class StorePaymentAnticipatedTransactionFormComponent implements OnInit {
  public userRole: any
  public formGroup: FormGroup
  public states: Object[] = []
  public plans: Object[] = []
  public storeID: any
  public store: Store
  public installments: any[] = [1]
  public isValidTotalValue = false
  public isValidTotalValueMsg = ''
  public reservationValueInvalid = false
  public headersTable: string[] = ['minimumTransactionValue', 'minimumInstallmentValue']
  public transactionsInfo: any[] = []
  public subStores: any[] = []
  public params = { formGroupValue: [], previousRoute: '', storeID: '', storeFormGroupValue: [] }

  constructor (
    public errorsService: ErrorsService,
    private readonly formBuilder: FormBuilder,
    public storeService: StoreService,
    public transactionService: TransactionService,
    private readonly router: Router,
    private readonly route: ActivatedRoute,
    public snackBar: MatSnackBar,
    public currencyPipe: CurrencyPipe,
  ) { }

  ngOnInit () {
    this.route.queryParams.subscribe((params) => {
      this.params.storeFormGroupValue = params.storeFormGroupValue
      this.params.formGroupValue = params.formGroupValue
      this.params.previousRoute = params.previousRoute
      this.params.storeID = params.storeID
      this.storeID = params.storeID
    })
    this.userRole = localStorage.getItem('userRole')
    this.initForm()
  }

  initForm () {
    if (!this.storeID) {
      this.storeID = this.route.snapshot.paramMap.get('storeID')
    }

    this.formGroup = this.formBuilder.group({
      customerCpf: [
        null,
        [Validators.required, Validators.minLength(11), Validators.maxLength(11)],
      ],
      totalValue: [null, [Validators.required]],
      description: [null, [Validators.required]],
      maximumInstallments: [1, [Validators.required]],
      isMembershipActive: [null, [Validators.required]],
      isPayActive: [null, [Validators.required]],
      reservationValue: [null, [Validators.required]],
      paymentDate: [null, [Validators.required]],
      maximumInstallmentsReserve: [null, [Validators.required]],
      subStoreId: [null, []],
    })

    if (this.storeID != '' && this.storeID != null) {
      const storeSelected = JSON.parse(localStorage.getItem('storeSelected'))
      if (storeSelected && this.userRole != 'ADMIN') {
        this.storeID = storeSelected.storeId
      }

      this.storeService.getStore(this.storeID).subscribe(response => {
        for (const st of response.subStoreAndMacroGroup) {
          if (st.subStore.length) {
            this.subStores.push(st.subStore[0])
          }
        }
        if (this.subStores.length) {
          this.subStores.sort((a, b) => {
            return a.subStoreName < b.subStoreName ? -1 : a.subStoreName > b.subStoreName ? 1 : 0
          })
        }
        this.store = response
        this.formGroup = this.formBuilder.group({
          customerCpf: [
            null,
            [Validators.required, Validators.minLength(11), Validators.maxLength(11)],
          ],
          totalValue: [null, [Validators.required]],
          description: [null, [Validators.required]],
          maximumInstallments: [1, [Validators.required]],
          isMembershipActive: [this.store.isMembershipActive, [Validators.required]],
          isPayActive: [this.store.isPayActive, [Validators.required]],
          reservationValue: [null, [Validators.required]],
          paymentDate: [null, [Validators.required]],
          maximumInstallmentsReserve: [null, [Validators.required]],
          subStoreId: [null, []],
        })

        this.transactionsInfo = [
          {
            minimumTransactionValue: this.store.minimumTransactionValue / 100,
            minimumInstallmentValue: this.store.minimumInstallmentValue / 100,
          },
        ]
      })
    }
  }

  changeValueTotal (event) {
    this.isValidTotalValue = false
    if (this.formGroup.value.totalValue * 100 >= this.store.minimumTransactionValue) {
      this.isValidTotalValueMsg = `O valor mínimo da Transação é de R$ ${this.store.minimumTransactionValue}`
      this.isValidTotalValue = true
      this.calcTotalInstallments()
    }
  }

  calcTotalInstallments () {
    this.installments = [1]
    for (let index = 2; index <= this.store.maximumInstallmentsPerTransaction; index++) {
      if ((this.formGroup.value.totalValue * 100) / index >= this.store.minimumInstallmentValue) {
        this.installments.push(index)
      }
    }
  }

  changeValueReservation () {
    if (this.formGroup.value.totalValue * 100 < this.formGroup.value.reservationValue * 100) {
      return (this.reservationValueInvalid = true)
    }
    return (this.reservationValueInvalid = false)
  }

  convertCentsToMoney (value) {
    this.currencyPipe.transform(value, 'BRL')
  }

  convertNumberToBoolean (num) {
    if (num == 0) {
      return false
    } else {
      return true
    }
  }

  async submit () {
    if (this.formGroup.value.totalValue * 100 < this.store.minimumTransactionValue) {
      this.formGroup.controls.totalValue.setErrors({ transactionNotMatch: true })
    } else {
      this.formGroup.controls.totalValue.setErrors(null)
    }
    if (this.formGroup.value.totalValue * 100 < this.formGroup.value.reservationValue * 100) {
      this.reservationValueInvalid = true
    } else {
      this.reservationValueInvalid = false
    }

    if (!this.formGroup.valid || this.reservationValueInvalid) {
      this.snackBar.open('Preencha corretamente os campos e tente novamente.')
      return false
    }

    const totalValue = this.formGroup.value.totalValue.toFixed(2).replace('.', '')
    const reservationValue = this.formGroup.value.reservationValue.toFixed(2).replace('.', '')
    const data = {
      customerCpf: this.formGroup.value.customerCpf,
      totalValue: parseInt(totalValue),
      descriptionPayment: this.formGroup.value.description,
      description: `${this.formGroup.value.description} (RESERVA)`,
      maximumInstallments: parseInt(this.formGroup.value.maximumInstallments),
      isMembershipActive: this.formGroup.value.isMembershipActive,
      isPayActive: this.formGroup.value.isPayActive,
      storeId: this.storeID,
      paymentDate: this.formGroup.value.paymentDate,
      reservationValue: parseInt(reservationValue),
      withReservation: true,
      maximumInstallmentsReserve: parseInt(this.formGroup.value.maximumInstallmentsReserve),
      subStoreId: this.formGroup.value.subStoreId,
    }

    this.transactionService.addTransaction(data).subscribe(
      response => {
        if (response.isCreated) {
          this.snackBar.open('Transação criada com sucesso.')
          this.router.navigate(['./dashboard/transactions/payment/' + response.paymentId], { queryParams: this.params, skipLocationChange: true })
        }
      },
      error => {
        this.snackBar.open(error.error.message)
      },
    )
  }
}
